"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M19 9H22C23.1046 9 24 9.89543 24 11V24H19V9Z", fill: "currentColor" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6C4 4.89543 4.89543 4 6 4H16C17.1046 4 18 4.89543 18 6V24H4V6ZM6 7H16V9H6V7ZM16 11H6V13H16V11ZM6 15H16V17H6V15ZM16 19H6V21H16V19Z", fill: "currentColor" })));
